var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingboxfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9.2656 -77.1113 79.2227 85.1308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.709 7.51953C52.002 7.42188 52.1973 7.32422 52.4414 7.17773L82.0801-9.86328C85.8398-12.0605 87.9883-14.209 87.9883-20.3613L87.9883-49.7559C87.9883-50.9277 87.8906-52.002 87.6465-52.9297L51.709-32.1777ZM46.0449 7.51953L46.0449-32.1777L10.1074-52.9297C9.86328-52.002 9.76562-50.9277 9.76562-49.7559L9.76562-20.3613C9.76562-14.209 11.9141-12.0605 15.6738-9.86328L45.3125 7.17773C45.5566 7.32422 45.8008 7.42188 46.0449 7.51953ZM48.877-37.1582L65.0391-46.3867L28.9551-67.2852L15.1367-59.375C14.2578-58.8867 13.5254-58.3984 12.8418-57.7637ZM70.8008-49.6582L84.9121-57.7637C84.2773-58.3984 83.4961-58.8867 82.6172-59.375L56.543-74.3652C53.9551-75.8301 51.416-76.6113 48.877-76.6113C46.3867-76.6113 43.7988-75.8301 41.2598-74.3652L34.4727-70.459Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingboxfill);
export default __webpack_public_path__ + "static/media/shippingbox.fill.9a0ae388cb53e63c7e0675c15e291e0a.svg";
export { ForwardRef as ReactComponent };